<template>
  <div class="home-wrap" :class="'theme-'+theme">
    <div class="h-wrap">
      <v-head class="o-head container" :change-theme="changeMainTheme"></v-head>
    </div>
    <div class="c-wrap container">

      <v-side :class="{'fixed-side': true}" class="s-content"></v-side>

      <div class="c-content">
        <v-la-ba @click="openDialog" :list="notices" class="s-horn"></v-la-ba>

        <!-- 内容 -->
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import Notice from '../../components/notice';
  import VHead from '../../components/common/headTabs';
  import VSide from '../../components/common/sideBars';
  import VLaBa from '../../components/c-laba';
  import {mapActions, mapState, mapGetters} from 'vuex';
  import Bus from '../../utils/bus';

  const find = (cb, el) => {
    if (el.name === 'app_notice') return cb(el);
    if (el.$children.length > 0) el.$children.forEach(child => find(cb, child));
  };

  export default {
    name: 'home',
    components: {
      Notice,
      VHead,
      VSide,
      VLaBa,
    },
    computed: {
      ...mapGetters('root', [
        'theme'
      ]),
      ...mapState('home', [
        'notices'
      ]),
      ...mapState([
        'notice'
      ])
    },
    watch: {
      theme: {
        handler(val) {
          Bus.$emit('changeTheme', val);
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions('root', [
        'changeMainTheme'
      ]),
      ...mapActions({
        loadInfo: 'loadNoticeDetail'
      }),
      openDialog(item) {
        if (!item.id) return;
        this.loadInfo(item.id);
        this.$MessageBox.show('d37', {
          title: '平台公告',
          noticeId: item.id
        });
      },

    }
  }
</script>

<style>
  html, body {
    height: 100%;
  }
</style>
<style scoped lang="stylus">
@media screen and (max-width: 900px) {
  .c-content{width:calc(100% - 36vw) !important;}
}
  .home-wrap
    min-width 1250px
    position relative
    width 100%

    .h-wrap
      top 0
      left 0
      width 100%
      height 44px
      z-index 1000
      position absolute

      .o-head
        margin 0 auto

    .c-wrap
      height 100%
      margin 0 auto
      position relative
      overflow hidden
      padding-top 48px

      .s-content
        float left

      .c-content
        float right
        width calc(100% - 220px)
        min-height 830px

      .s-horn
        width 100%
        background linear-gradient(#FFFFFF, #ECECEC)
        margin-bottom 5px
        border-radius 2px
        background-color #ffffff

  .theme-2 .home-wrap .h-wrap
  {
	//background linear-gradient(#28b32a,#05971e)!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue